<template>
  <v-container class="event-selector-container">
    <v-row dense row wrap class="event-selector-row">
      <v-col class="col-5">
        <span class="ml-4 name-label application-heading">{{
          topic.plural
        }}</span>
      </v-col>
      <v-col class="col-1">
        <v-switch
          v-model="switchEnabled"
          @click="toggleSwitch"
          class="event-input-toggle pa-0 ma-0"
          solo
          item-text="display"
          return-object
        ></v-switch>
      </v-col>
    </v-row>
    <v-row dense row wrap>
      <v-col class="col-11">
        <ul class="category-list">
          <li :key="item.id" v-for="item in availableItems">
            <v-checkbox
              :label="item.name"
              v-model="item.selected"
              @click="handleCheckboxChange"
              class="category-input"
              dense
            ></v-checkbox>
          </li>
        </ul>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import lodashOrderBy from "lodash/orderBy";
import { ICONS } from "@/common/constants/icons";

const EMITTED_ACTIONS = {
  CHANGED: "changed",
};

export default {
  name: "EventSelector",
  props: {
    topic: {
      topic: Object,
      required: true,
    },
    selectedCategories: {
      type: Array,
    },
  },
  data() {
    return {
      switchEnabled: false,
      availableItems: null,
    };
  },
  computed: {
    imgSrc() {
      if (!this.topic.type || !ICONS || !ICONS.types[this.topic.type]) {
        return null;
      }
      const src = ICONS.types[this.topic.type].active;
      return require(`@/assets/images${src}`);
    },
  },
  mounted() {
    if (
      this.topic.legacyAlertCategories &&
      Array.isArray(this.topic.legacyAlertCategories)
    ) {
      this.availableItems = lodashOrderBy(
        this.topic.legacyAlertCategories,
        ["name"],
        ["asc"]
      );
    }
    this.initialize();
  },
  methods: {
    initialize() {
      this.setSwitchState();
      this.selectedCategories.map((selectedCat) => {
        this.availableItems.map((availableCat) => {
          if (availableCat.id === selectedCat.id) {
            availableCat.selected = selectedCat.selected;
          }
        });
      });
    },
    setSwitchState() {
      let isSwitchEnabled = false;
      for (let i = 0; i < this.selectedCategories.length; i++) {
        const cat = this.selectedCategories[i];
        isSwitchEnabled = isSwitchEnabled || cat.selected;
        if (isSwitchEnabled) {
          break;
        }
      }
      this.switchEnabled = isSwitchEnabled;
    },
    toggleSwitch() {
      this.availableItems.map((item) => (item.selected = this.switchEnabled));
      this.emitChanges();
    },
    emitChanges() {
      const CATEGORIES = this.availableItems.reduce((accum, item) => {
        if (item.selected) {
          accum.push(item.id);
        }
        return accum;
      }, []);
      this.$emit(EMITTED_ACTIONS.CHANGED, {
        type: this.topic.type,
        toggle: this.switchEnabled,
        categories: CATEGORIES,
        useMainTopic: CATEGORIES.length === this.availableItems.length,
      });
    },
    handleCheckboxChange() {
      this.emitChanges();
    },
  },
  watch: {
    selectedCategories: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.event-selector-container {
  padding: 0 0 5px 0 !important;
}
.event-selector-row {
  height: 20px;
}

.name-label {
  font-size: 16px !important;
  margin: 0 0 0 10px !important;
}
.topic-image {
  height: 20px;
  width: 20px;
  margin: 0 0 2px 0;
  vertical-align: middle;
}
.category-list {
  list-style-type: none;
  padding: 0 0 0 16px;
}
.category-input {
  margin: 4px;
}
.category-input >>> .v-label {
  font-size: 13px !important;
}
.category-input >>> .v-messages {
  min-height: 0 !important;
}
.category-input >>> .v-input__slot {
  margin: 0 !important;
}
</style>
